function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.231,2.154a3.231,3.231,0,1,0,0,6.461c.073,0,.142-.016.214-.021a2.8,2.8,0,0,1-2.368,1.1,1.077,1.077,0,0,0,0,2.154c3.569,0,5.385-2.893,5.385-6.461A3.231,3.231,0,0,0,3.231,2.154Z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.769,2.154a3.231,3.231,0,1,0,0,6.461c.074,0,.143-.016.215-.021a2.8,2.8,0,0,1-2.369,1.1,1.077,1.077,0,0,0,0,2.154C12.184,11.846,14,8.953,14,5.385A3.23,3.23,0,0,0,10.769,2.154Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/quote.ea9cc60b.svg";
export { SvgComponent as ReactComponent };